import createIcon from '../../createIcon';

/**
 * @component @name Timer3Select
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSAxMVYxM0gxNi41VjE0SDE5QzE5LjgzIDE0IDIwLjUgMTQuNjggMjAuNSAxNS41VjE3LjVDMjAuNSAxOC4zMyAxOS44MyAxOSAxOSAxOUgxNC41VjE3SDE4LjVWMTZIMTZDMTUuMTggMTYgMTQuNSAxNS4zMiAxNC41IDE0LjVWMTIuNUMxNC41IDExLjY4IDE1LjE4IDExIDE2IDExSDIwLjVaTTMuNSA1VjhIOS41VjEwLjVIMy41VjEzLjVIOS41VjE2SDMuNVYxOUg5LjVDMTEuMTYgMTkgMTIuNSAxNy42NiAxMi41IDE2VjE0LjFDMTIuNSAxMi45NCAxMS41NiAxMiAxMC40IDEyQzExLjU2IDEyIDEyLjUgMTEuMDYgMTIuNSA5LjlWOEMxMi41IDYuMzQgMTEuMTYgNSA5LjUgNUgzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Timer3Select = createIcon('Timer3Select', [
  [
    'path',
    {
      d: 'M20.5 11V13H16.5V14H19C19.83 14 20.5 14.68 20.5 15.5V17.5C20.5 18.33 19.83 19 19 19H14.5V17H18.5V16H16C15.18 16 14.5 15.32 14.5 14.5V12.5C14.5 11.68 15.18 11 16 11H20.5ZM3.5 5V8H9.5V10.5H3.5V13.5H9.5V16H3.5V19H9.5C11.16 19 12.5 17.66 12.5 16V14.1C12.5 12.94 11.56 12 10.4 12C11.56 12 12.5 11.06 12.5 9.9V8C12.5 6.34 11.16 5 9.5 5H3.5Z',
      key: '14s9oz',
    },
  ],
]);

export default Timer3Select;
